import { getData } from "./index.svc"

export const materialList = async () => {
    return await getData(`materials/list`)
}

export const materialsByJobNumber = async(jobNumber, showAll = false) => {
    const qs = showAll ? '?all=1' : ''
    return await getData(`jobs/${jobNumber}/materials${qs}`)
}

export const createJobMaterial = async (body) => await getData(`jobs/${body.JobNumber}/materials`, 'POST', body)

export const updateJobMaterial = async (body) => await  getData(`jobs/${body.JobNumber}/materials/${body.ID}`, 'POST', body)

export const deleteJobMaterial = async (id, jobNumber) => await  getData(`jobs/${jobNumber}/materials/${id}?Active=No`, 'DELETE')

export const restoreJobMaterial = async (id, jobNumber) => await  getData(`jobs/${jobNumber}/materials/${id}?Active=Yes`, 'DELETE')